import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'swb-mce-browse',
  templateUrl: './mce-browse.component.html',
  styleUrls: ['./mce-browse.component.scss']
})
export class MceBrowseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
